// extracted by mini-css-extract-plugin
module.exports = {"container":"MinimumTotalOrderBadge_container__D2_0A","badge":"MinimumTotalOrderBadge_badge__3gKkU typeography_ui11Medium__eulDk"};